export const errorTextStyles = {
  color: '#c4314b',
};
